import { useEffect, useRef, useState } from 'react';
import { copyToClipboard, parsePhone, parsePrice, parseRequestNumber, parseStatus } from '../../../../../assets/utils/utils';
import { PAYMENT_TYPE_VALUES } from '../../../../../assets/utils/constants';
import './OrderInfo.css';
import { LinkIcon } from '../../../../../assets/icons/controls/controls';
import moment from 'moment-timezone';

function OrderInfo({
    order,
}) {


    const requestNumber = parseRequestNumber(order.ai_id)
    const statusLabel = parseStatus(order.status, order.payment_type, order.delivery_type);
    const phone = parsePhone(order.phone)
    const email = order.email
    const fullName = [order.first_name, order.last_name]
        .filter(Boolean)
        .join(" ");
    const [copiedField, setCopiedField] = useState(null);
    const copyTimerRef = useRef(null);

    function handleCopy(field, value) {
        if (!value) return;
        copyToClipboard(value);
        setCopiedField(field);

        if (copyTimerRef.current) {
            clearTimeout(copyTimerRef.current);
        }
        copyTimerRef.current = setTimeout(() => {
            setCopiedField(null);
            copyTimerRef.current = null;
        }, 2000);
    }

    useEffect(() => () => {
        if (copyTimerRef.current) {
            clearTimeout(copyTimerRef.current);
        }
    }, []);



    return (
        <div
            className={`order-info order-info_status_${order.status}`}
            key={`order-info-${order._id}`}
        >
            <header className="order-info__header">
                <div className="order-info__title-block">
                    <span className="order-info__label">
                        Номер заказа
                    </span>
                    <p className="order-info__number">
                        {requestNumber}
                    </p>
                </div>
                <span
                    className={`order-info__status`}
                >
                    {statusLabel}
                </span>
            </header>

            <div className="order-info__body">
                <div className="order-info__row">
                    <span className="order-info__label">Клиент</span>
                    <span className="order-info__value">
                        {fullName || "Не указано"}
                    </span>
                </div>

                <div className="order-info__grid">
                    <div className="order-info__col">
                        <button
                            type="button"
                            className={`order-info__copy ${copiedField === 'phone' ? 'order-info__copy_copied' : ''}`}
                            onClick={() => handleCopy('phone', phone)}
                            disabled={!phone}
                            title={phone || undefined}
                        >
                            <div className="order-info__copy-top">
                                <span className="order-info__label">Телефон</span>
                                {phone ? <LinkIcon
                                    mainClassName={'order-info__copy-icon'}
                                    strokeClassName={'order-info__copy-icon-stroke'}
                                /> : null}
                            </div>
                            <span className="order-info__value order-info__value_link">
                                {phone || "—"}
                            </span>
                        </button>
                    </div>
                    <div className="order-info__col">
                        <button
                            type="button"
                            className={`order-info__copy ${copiedField === 'email' ? 'order-info__copy_copied' : ''}`}
                            onClick={() => handleCopy('email', email)}
                            disabled={!email}
                            title={email || undefined}
                        >
                            <div className="order-info__copy-top">
                                <span className="order-info__label">Почта</span>
                                {email ? <LinkIcon
                                    mainClassName={'order-info__copy-icon'}
                                    strokeClassName={'order-info__copy-icon-stroke'}
                                /> : null}
                            </div>
                            <span className="order-info__value order-info__value_link">
                                {email || "—"}
                            </span>
                        </button>
                    </div>
                    <div className="order-info__col">
                        <span className="order-info__label">Оплата</span>
                        <span className="order-info__value">
                            {order.payment_type ? PAYMENT_TYPE_VALUES[order.payment_type] : "—"}
                        </span>
                    </div>
                    <div className="order-info__col">
                        <span className="order-info__label">Дата</span>
                        <span className="order-info__value">
                            {order.utc_date ? moment(order.utc_date).format('DD.MM.YYYY HH:mm') : "—"}
                        </span>
                    </div>
                    <div className="order-info__col order-info__col--highlight">
                        <span className="order-info__label">Сумма</span>
                        <span className="order-info__price">
                            {parsePrice(order.total_price, 'RUB')}
                        </span>
                    </div>
                   

                </div>
            </div>
        </div>
    );
}

export default OrderInfo
